<template>
  <div class="col-sm-12 col-md-12 col-xs-12 sm_scroll box_wrapper">
    <div class="row content">
      <div class="col-md-6 col-sm-6">
        <div class="form-group">
          <label for class="header-label">
            First Name
            <span class="required_astric" v-if="!user_data.first_name">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.first_name.$error ? 'invalid-border' : ''"
            v-model.trim="$v.user_data.first_name.$model"
            type="text"
            placeholder="First Name"
            maxlength="65"
          />
          <div v-if="$v.user_data.first_name.$error">
            <div class="custom-error-class" v-if="!$v.user_data.first_name.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-else-if="!$v.user_data.first_name.minLength">
              Minimum 2 characters required.
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="form-group">
          <label for class="header-label">
            Last Name
            <span class="required_astric" v-if="!user_data.last_name">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.last_name.$error ? 'invalid-border' : ''"
            type="text"
            placeholder="Last Name"
            v-model.trim="$v.user_data.last_name.$model"
            maxlength="65"
          />
          <div v-if="$v.user_data.last_name.$error">
            <div class="custom-error-class" v-if="!$v.user_data.last_name.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-else-if="!$v.user_data.last_name.minLength">
              Minimum 2 characters required.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- email nd phone -->
    <div class="row content">
      <div class="col-md-6 col-sm-6">
        <div class="form-group">
          <label for class="header-label">
            Email address
            <span class="required_astric" v-if="!user_data.email_address">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.email_address.$error ? 'invalid-border' : ''"
            type="text"
            placeholder="Email"
            v-model.trim="$v.user_data.email_address.$model"
            maxlength="65"
          />
          <div v-if="$v.user_data.email_address.$error">
            <div class="custom-error-class" v-if="!$v.user_data.email_address.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-else-if="!$v.user_data.email_address.isValidMail">
              Invalid email format. Valid entries include: someone@example.com.
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="form-group">
          <label for class="header-label">
            Phone number
            <span class="required_astric" v-if="!user_data.phone_number">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.phone_number.$error ? 'invalid-border' : ''"
            type="text"
            size="15"
            maxlength="20"
            placeholder="Phone number"
            v-model.trim="$v.user_data.phone_number.$model"
          />
          <div v-if="$v.user_data.phone_number.$error">
            <div class="custom-error-class" v-if="!$v.user_data.phone_number.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-if="!$v.user_data.phone_number.isNumber">
              Please enter only numbers
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <hr class="billing-info-line" />
    </div>

    <!-- Address -->
    <div class="row content">
      <div class="col-md-12 col-sm-12">
        <div class="form-group">
          <label for class="header-label">
            Address
            <span class="required_astric" v-if="!user_data.address">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.address.$error ? 'invalid-border' : ''"
            type="text"
            size="60"
            placeholder="Street Address"
            v-model.trim="$v.user_data.address.$model"
          />
          <div v-if="$v.user_data.address.$error">
            <div class="custom-error-class" v-if="!$v.user_data.address.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-if="!$v.user_data.address.isAllowedCharacters">
              {{ specialCharacterErrMsg }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- city, state nd zip -->
    <div class="row content">
      <div class="col-md-6 col-sm-6">
        <div class="form-group">
          <label for class="header-label">
            City
            <span class="required_astric" v-if="!user_data.city">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.city.$error ? 'invalid-border' : ''"
            type="text"
            size="60"
            maxlength="50"
            placeholder="City"
            v-model.trim="$v.user_data.city.$model"
          />
          <div v-if="$v.user_data.city.$error">
            <div class="custom-error-class" v-if="!$v.user_data.city.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-if="!$v.user_data.city.minLength">
              Minimum 3 characters required.
            </div>
            <div class="custom-error-class" v-else-if="!$v.user_data.city.isAllowedCharacters">
              {{ specialCharacterErrMsg }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-2">
        <div class="form-group">
          <label for class="header-label">
            State
            <span class="required_astric" v-if="!user_data.state">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.state.$error ? 'invalid-border' : ''"
            type="text"
            size="60"
            maxlength="50"
            placeholder="State"
            v-model.trim="$v.user_data.state.$model"
          />
          <div v-if="$v.user_data.state.$error">
            <div class="custom-error-class" v-if="!$v.user_data.state.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-if="!$v.user_data.state.isAllowedCharacters">
              {{ specialCharacterErrMsg }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4">
        <div class="form-group">
          <label for class="header-label">
            Zip Code
            <span class="required_astric" v-if="!user_data.zipcode">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.zipcode.$error ? 'invalid-border' : ''"
            type="text"
            maxlength="15"
            placeholder="Zip / Postal code"
            v-model.trim="$v.user_data.zipcode.$model"
          />
          <div v-if="$v.user_data.zipcode.$error">
            <div class="custom-error-class" v-if="!$v.user_data.zipcode.required">
              Complete required field
            </div>
            <div class="custom-error-class" v-if="!$v.user_data.zipcode.minLength">
              Minimum 2 characters required.
            </div>
            <div
              class="custom-error-class"
              v-else-if="!$v.user_data.zipcode.isPostalCode && user_data.zipcode"
            >
              Valid Zip/Postal Code Required
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- country -->
    <div class="row content">
      <div class="col-md-6 col-sm-6" v-if="purchaseOrder">
        <div class="form-group">
          <label for class="header-label">
            Purchase Order
            <span class="required_astric" v-if="!user_data.purchase_order">*</span>
          </label>
          <input
            class="form-control"
            :class="$v.user_data.purchase_order.$error ? 'invalid-border' : ''"
            type="text"
            placeholder="Purchase Order"
            v-model.trim="$v.user_data.purchase_order.$model"
          />
          <div v-if="$v.user_data.purchase_order.$error">
            <div class="custom-error-class" v-if="!$v.user_data.purchase_order.required">
              Complete required field
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="form-group">
          <label for class="header-label">
            Country
            <span class="required_astric" v-if="!user_data.country">*</span>
          </label>
          <multiselect
            class="VMSelectCss overflow-country mr-bt--6"
            :class="$v.user_data.country.$error ? 'invalid' : ''"
            :allow-empty="false"
            placeholder="Select a country"
            label="country_name"
            v-model.trim="$v.user_data.country.$model"
            :show-labels="false"
            :options="countriesList.map((type) => type.country_name)"
            :custom-label="getCountryLabel"
          ></multiselect>

          <div
            class="custom-error-class"
            v-if="!$v.user_data.country.required && $v.user_data.country.$error"
          >
            Complete required field
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'; //eslint-disable-line
import { validateData, purchaseOrderObject } from '../../MarketPlace/PSM/BillingInfoValidator';
import { getAllCountries } from '../../../apis/countriesList';

export default {
  components: {},
  props: ['purchaseOrder'],
  data() {
    return {
      user_data: {
        first_name: '',
        last_name: '',
        email_address: '',
        country: '',
        phone_number: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        purchase_order: ''
      },
      countriesList: [],
      validateFormSubmit: false
    };
  },
  validations() {
    if (this.purchaseOrder) {
      return { user_data: purchaseOrderObject };
    }
    return { user_data: validateData };
  },
  watch: {
    purchaseOrder() {
      this.$set(this.user_data, 'purchase_order', '');
    }
  },
  async created() {
    await this.getCountryList();
  },
  methods: {
    async getCountryList() {
      if (localStorage.getItem('countryList')) {
        this.countriesList = JSON.parse(localStorage.getItem('countryList'));
      } else {
        this.countriesList = await getAllCountries();
      }
    },
    getCountryLabel(opt) {
      return this.countriesList.find((x) => x.country_name === opt).country_name;
    }
  }
};
</script>

<style lang="scss" scoped>
@media (width: 768px) {
  .sm_scroll.box_wrapper {
    height: 50vh;
  }
}
@media screen and (max-width: 767px) {
  .sm_scroll.box_wrapper {
    height: 70vh;
  }
}
@media (min-width: 769px) {
  .sm_scroll.box_wrapper {
    height: 65vh;
  }
}
.box_wrapper {
  overflow-y: auto;
  overflow-x: hidden;
}
.billing-info-line {
  margin-top: 24px;
  margin-bottom: 22px;
}
p {
  &.billing-contact-para {
    padding-bottom: 12px;
    font-size: $font-24;
    line-height: 28px;
    color: $dark-black-alpha;
  }
}
.comn_border {
  background: $deep-white;
  border: 0.5px solid $black;
  box-sizing: border-box;
  border-radius: 3px;
}
.required_astric {
  font-size: $font-12;
  color: red;
  margin-left: 2px;
  vertical-align: top;
}
.custom-error-class {
  padding-top: 8px;
}
.header-label {
  font-size: $font-14;
  line-height: 16px;
  color: $dark-black-alpha;
}
::v-deep .VMSelectCss {
  .multiselect__content-wrapper {
    min-height: 0px;
    max-height: 180px !important;
    border: 1px solid #aaa;
    .multiselect__option--highlight {
      color: $black;
      height: 30px;
      background: $thick-white;
    }
  }
  .multiselect__option--selected {
    &:before {
      content: '\f00c';
      font-family: FontAwesome;
      font-style: normal;
      font-weight: normal;
      text-decoration: inherit;
      color: green;
      float: right;
    }
  }
  .multiselect__tags {
    border-radius: $radius15;
    min-height: 0;
    height: 33px;
    line-height: 12px;
    border: 1px solid $black;
    padding-top: 6px;
  }
  .multiselect__placeholder {
    padding-top: 4px;
  }
  .multiselect__option {
    height: 30px;
    font-size: 13px;
  }
  .multiselect__single {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: $font-14;
  }
  .multiselect__select {
    height: 35px;
    &:before {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      border: 1px solid $primary;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 4px;
      top: 0;
      content: '';
    }
  }
  .multiselect__element {
    .multiselect__option {
      span {
        word-break: break-word;
        white-space: pre-wrap;
      }
    }
  }
  &.multiselect--active {
    .multiselect__tags {
      border-radius: $radius20;
    }
  }
}
.mr-bt--6 {
  margin-bottom: -6px;
}
::v-deep .overflow-country {
  .multiselect__content-wrapper {
    overflow-y: scroll;
  }
}

.ps_lt_10_6 {
  left: 5.5em;
  top: 0.1px;
}
</style>
